import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { InstantSearch, Hits } from 'react-instantsearch/dom'
import { push } from 'react-router-redux'
import axios from 'axios'

// Styles
import styles from './styles'

// Material UI
import Card, { CardActions, CardContent } from 'material-ui/Card'
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import TextField from 'material-ui/TextField'
import Button from 'material-ui/Button'

class Summary extends Component {
  constructor(props) {
    super(props)

    this.state = {
      name: '',
      popCount: '~',
      income_levels: [
        'Everyone',
        'Up to $25,000',
        '$25,000 and above',
        '$35,000 and above',
        '$50,000 and above',
        '$75,000 and above',
        '$100,000 and above',
        '$150,000 and above'
      ],
      education_levels: [
        'Everyone',
        'High School or above',
        'Some College or above',
        'Associate Degree or above',
        'Bachelor Degree or above',
        'Graduate Degree or above',
        'PHD / Post Doctoral'
      ]
    }
  }

  async handleSubmit() {
    let currentComponent = this

    let randomNumberID = Math.floor(Math.random() * 100) + 1

    var today = new Date()
    var dd = today.getDate()
    var mm = today.getMonth() + 1
    var yyyy = today.getFullYear()

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = mm + '-' + dd + '-' + yyyy
    let name =
      today +
      ' - ' +
      this.props.oarlow +
      ' to ' +
      this.props.oarhigh +
      ' and ' +
      this.props.agelow +
      ' to ' +
      this.props.agehigh

    //console.log('https://api.dsnapis.com/insert/1/pw/teSt1/filterid/'+randomNumberID+'/filtername/'+this.state.name+'/dschigh/5/dsclow/1/agehigh/'+this.props.agehigh+'/agelow/'+this.props.agelow+'/oarhigh/'+this.props.oarhigh+'/oarlow/'+this.props.oarlow+'/herprefage/'+this.props.old_age+'/herprefans/0/clrhigh/5/clrlow/1')
    //console.log('https://api.dsnapis.com/insert/2/pw/teSt1/filterid/'+randomNumberID+'/filtername/'+name+'/dschigh/5/dsclow/1/agehigh/'+this.props.agehigh+'/agelow/'+this.props.agelow+'/oarhigh/'+this.props.oarhigh+'/oarlow/'+this.props.oarlow+'/herprefage/'+this.props.old_age+'/herprefans/'+this.props.pref_fans+'/clrhigh/5/clrlow/1')
    //http://139.146.141.2:5001/insert/1/pw/teSt1/filterid/30/filtername/Search POST TEST 30, Age 44-52, OAR 8-10, All DSC/dschigh/5/dsclow/1/agehigh/52/agelow/44/oarhigh/10/oarlow/8/herprefage/50/herprefans/0/clrhigh/5/clrlow/1/education/0/income/1
    // We susbsitute post request with get and add it as a parameter

    let education = this.props.education
    if (this.props.education == 0) {
      education = -1
    }

    let income = this.props.income
    if (this.props.income == 0) {
      income = -1
    }

    await axios
      .post(
        'https://api.dsnapis.com/insert/' +
          this.props.customer_number +
          '/pw/teSt1/filterid/' +
          randomNumberID +
          '/filtername/' +
          this.state.name +
          '/dschigh/5/dsclow/1/agehigh/' +
          this.props.agehigh +
          '/agelow/' +
          this.props.agelow +
          '/oarhigh/' +
          this.props.oarhigh +
          '/oarlow/' +
          this.props.oarlow +
          '/herprefage/' +
          this.props.old_age +
          '/herprefans/' +
          this.props.pref_fans +
          '/clrhigh/5/clrlow/1/education/' +
          education +
          '/income/' +
          income,
        {
          params: {
            type: 'post'
          }
        }
      )
      .then(function(response) {
        currentComponent.props.changeRoute('/console/search/saved_searches')
      })
    /*
    axios({
      method: 'get',
      url: 'http://[::]:8080/v1/proxy?url=http://139.146.141.2:5001/insert/2/pw/teSt1/filterid/'+randomNumberID+'/filtername/'+name+'/dschigh/5/dsclow/1/agehigh/'+this.props.agehigh+'/agelow/'+this.props.agelow+'/oarhigh/'+this.props.oarhigh+'/oarlow/'+this.props.oarlow+'/herprefage/'+this.props.old_age+'/herprefans/'+this.props.pref_fans+'/clrhigh/5/clrlow/1',
      params: {
        "type":"post",
      }
    }).then(function (response) {
      alert(JSON.stringify(response))
      currentComponent.props.changeRoute("/console/search/saved_searches");
    });*/

    //this.props.changeRoute("/console/search/create_new_search/six_basic_filters/set_name")
  }

  handleChange = name => event => {
    if (event.target.value.includes('/') || event.target.value.includes(',')) {
      alert("You cannot use the '/' or ',' characters.")
    } else {
      this.setState({
        [name]: event.target.value
      })
    }
  }

  getDistribution() {
    let currentComponent = this
    // Get Population Count
    //alert('https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/5/dsclow/1/agehigh/'+this.state.oldest+'/agelow/'+this.state.youngest+'/oarhigh/'+this.props.oarhigh+'/oarlow/'+this.props.oarlow+'/herprefage/50/herprefans/0/clrhigh/5/clrlow/1')
    /*axios({
          method:'get',
          url:'https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/5/dsclow/0/agehigh/'+this.props.agehigh+'/agelow/'+this.props.agelow+'/oarhigh/'+this.props.oarhigh+'/oarlow/'+this.props.oarlow+'/herprefage/'+this.props.old_age+'/herprefans/'+this.props.pref_fans+'/clrhigh/5/clrlow/1/education/'+this.props.education+'/income/'+this.props.income+'/cust/2',
          responseType:'stream'
        }).then(function(response) {

          console.log(response.data[0]["SearchCount"]);
          currentComponent.setState({
            popCount: response.data[0]["SearchCount"],
          });
    });*/
  }

  componentDidMount() {
    this.getDistribution()
    this.setAutoName()
  }

  setAutoName() {
    var today = new Date()
    var dd = today.getDate()
    var mm = today.getMonth() + 1
    var yyyy = today.getFullYear()

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = mm + '-' + dd + '-' + yyyy
    let name =
      today +
      ' - ' +
      this.props.oarlow +
      ' to ' +
      this.props.oarhigh +
      ' and ' +
      this.props.agelow +
      ' to ' +
      this.props.agehigh
    this.setState({
      name: name
    })
  }

  render() {
    const { classes, theme, location } = this.props

    if (this.props.step < 2) {
      alert(
        'Please go through creating the search one step at a time before visiting the summary page.'
      )
      this.props.changeRoute(
        '/console/search/create_new_search/six_basic_filters'
      )
    }

    return (
      <div className={classes.root}>
        <main className={classes.content}>
          <Typography
            className={classes.textF}
            type="title"
            color="primary"
            gutterBottom
            align="center"
          >
            New Search Summary
          </Typography>
          <br />
          <Card className={classes.card}>
            <CardContent>
              <br />
              <Typography type="body2" gutterBottom align="left">
                Distance: 40 Mile Radius
              </Typography>
              <Typography gutterBottom align="left">
                Population Count: {this.props.first_pop_count}
              </Typography>
              <br />
              <Typography type="body2" gutterBottom align="left">
                OAR: {this.props.oarlow} - {this.props.oarhigh}
              </Typography>
              <Typography gutterBottom align="left">
                Population Count: {this.props.second_pop_count}
              </Typography>
              <br />
              <Typography type="body2" gutterBottom align="left">
                Age: {this.props.agelow} - {this.props.agehigh}
              </Typography>
              <Typography gutterBottom align="left">
                Population Count: {this.props.third_pop_count}
              </Typography>
              <br />
              <Typography type="body2" gutterBottom align="left">
                Candidate's Preferred Age: {this.props.old_age}
              </Typography>
              <Typography gutterBottom align="left">
                Population Count: {this.props.fourth_pop_count}
              </Typography>
              <br />
              <Typography type="body2" gutterBottom align="left">
                Education: {this.state.education_levels[this.props.education]}
              </Typography>
              <Typography gutterBottom align="left">
                Population Count: {this.props.fifth_pop_count}
              </Typography>
              <br />
              <Typography type="body2" gutterBottom align="left">
                Income: {this.state.income_levels[this.props.income]}
              </Typography>
              <Typography gutterBottom align="left">
                Population Count: {this.props.sixth_pop_count}
              </Typography>
              <br />
              <br />
              <Typography type="body2" gutterBottom align="center">
                Final Population Count: {this.props.sixth_pop_count}
              </Typography>
            </CardContent>
          </Card>
        </main>
        <br />
        <br />
        <TextField
          id="SearchByName"
          label="Name for your saved search, Click to Edit"
          className={classes.textField}
          value={this.state.name}
          onChange={this.handleChange('name')}
          margin="normal"
        />
        <br />
        <Button
          raised
          color="primary"
          align="center"
          onClick={() => this.handleSubmit()}
          className={classes.button}
        >
          Save your search
        </Button>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id,
    step: state.step.step,
    agelow: state.age.low,
    agehigh: state.age.high,
    oarlow: state.oar.low,
    oarhigh: state.oar.high,
    old_age: state.old_age,
    pref_fans: state.pref_fans,
    education: state.education.education,
    income: state.income.income,
    first_pop_count: state.first_pop_count,
    second_pop_count: state.second_pop_count,
    third_pop_count: state.third_pop_count,
    fourth_pop_count: state.fourth_pop_count,
    fifth_pop_count: state.fifth_pop_count,
    sixth_pop_count: state.sixth_pop_count
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    changeRoute: url => dispatch(push(url))
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, mapDispatchToProps)(Summary)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/CreateNewSearch/scenes/SixBasicFilters/scenes/Summary/index.js